var _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAwsCognito(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 261,
    height: 261,
    viewBox: "0 0 261 261",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188.5 37H72.5C55.103 37 41 51.103 41 68.5V184.5C41 201.897 55.103 216 72.5 216H188.5C205.897 216 220 201.897 220 184.5V68.5C220 51.103 205.897 37 188.5 37Z",
    fill: "white",
    stroke: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_56)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80 77H180V177H80V77Z",
    fill: "url(#paint0_linear_1_56)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.5 118.5H117.5V116H102.5V118.5ZM157.5 108.5V99.25C157.5 97.4575 156.337 96 154.907 96H100.092C98.6875 96 97.5 97.49 97.5 99.25V108.5H125V99.75C125 99.4185 125.132 99.1005 125.366 98.8661C125.601 98.6317 125.918 98.5 126.25 98.5H153.75C154.082 98.5 154.399 98.6317 154.634 98.8661C154.868 99.1005 155 99.4185 155 99.75V108.5H157.5ZM135 111C135 113.76 137.242 116 140 116C142.758 116 145 113.76 145 111C145 108.242 142.758 106 140 106C137.242 106 135 108.242 135 111ZM157.5 111H155V123.5H152.5V101H127.5V122.74C129.262 119.864 132.016 117.733 135.243 116.75C134.389 116.054 133.7 115.177 133.226 114.183C132.752 113.189 132.504 112.102 132.5 111C132.5 106.865 135.865 103.5 140 103.5C144.135 103.5 147.5 106.865 147.5 111C147.5 113.415 146.332 115.542 144.557 116.915C147.605 117.967 150.27 120.022 151.953 122.8L149.815 124.095C148.327 121.65 145.979 119.85 143.232 119.045C142.122 119.56 140.912 119.827 139.688 119.827C138.463 119.827 137.253 119.56 136.143 119.045C134.018 119.66 132.119 120.883 130.68 122.563C129.24 124.243 128.323 126.306 128.04 128.5H137.5V131H126.25C125.918 131 125.601 130.868 125.366 130.634C125.132 130.399 125 130.082 125 129.75V111H97.5V135.253C97.5 137.013 98.6875 138.5 100.092 138.5H132.5V141H100.092C97.285 141 95 138.423 95 135.253V99.25C95 96.08 97.285 93.5 100.092 93.5H154.907C157.715 93.5 160 96.08 160 99.25V128.5H157.502L157.5 111ZM162.5 146C162.5 152.892 156.892 158.5 150 158.5C143.108 158.5 137.5 152.892 137.5 146C137.5 139.11 143.108 133.5 150 133.5C156.892 133.5 162.5 139.11 162.5 146ZM165 146C165 137.73 158.273 131 150 131C141.727 131 135 137.73 135 146C135 154.273 141.727 161 150 161C158.273 161 165 154.273 165 146ZM149.655 150.655L158.94 141.373L157.172 139.605L148.773 148.005L144.988 144.22L143.22 145.988L147.888 150.655C148.122 150.889 148.44 151.021 148.771 151.021C149.103 151.021 149.421 150.889 149.655 150.655ZM115 126H120V123.5H115V126ZM102.5 126H112.5V123.5H102.5V126Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_56",
    x: 0.5,
    y: 0.5,
    width: 260,
    height: 260,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0367917 0 0 0 0 0.0348958 0 0 0 0 0.0484375 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_56"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_56",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_56",
    x1: 80,
    y1: 10077,
    x2: 10080,
    y2: 77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD0816"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5252"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_56"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white",
    transform: "translate(80 77)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwsCognito);
export default __webpack_public_path__ + "static/media/aws-cognito.d5f760a4986f810e5cf7950175d66e6d.svg";
export { ForwardRef as ReactComponent };